import { createSlice } from "@reduxjs/toolkit";

// Initial state of the shopping cart
const initialState = {
    shoppingCartData: [],
};

const shoppingCartSlice = createSlice({
    name: "shoppingCart",
    initialState,
    reducers: {
        // Reducer to set shopping cart data
        setShoppingCartData: (state, action) => {
            state.shoppingCartData = action.payload;
        },
    },
});

export const { setShoppingCartData } = shoppingCartSlice.actions;

export default shoppingCartSlice.reducer;
